import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import Navbar from './Navbar';
import { Collapse, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { getMenues } from '../../Service/menues';
import { getAppVersion } from '../../Config.js';

const drawerWidth = 240;

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    //padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,

}));


const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);

export default function MiniDrawer(props) {

    const [open, setOpen] = useState(false);
    const [isFixed, setIsFixed] = useState(false);

    const [openMenu, setOpenMenu] = useState([]);
    const [menuItems, setmenuItems] = useState([]);
    const [loading, setLoading] = useState(false)
    const [appVersion, setAppVersion] = useState('Cargando...');
    useEffect(() => {
    const fetchVersion = async () => {
      const version = await getAppVersion();
      setAppVersion(version);
    };
    fetchVersion();
  }, []);

    let nivel = -1;

    /*Busco los items de menu*/
    useEffect(() => {

        setLoading(true);

        getMenues()
            .then((data) => {
                setmenuItems(data);
                setLoading(false);
            })
            .catch()
    }, [])

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = (origen) => {
        //si entró acá por leave (origen = L) o por Navbar (origen = N)

        if (origen === 'N') {
            setOpen(false);
        } else {
            if (origen === 'L' && !isFixed) {
                setOpen(false);
            }
        }
    };

    const handlerDrawerFixed = () => {
        setIsFixed(!isFixed);
    }

    const handleClick = (item) => () => {
        const currentIndex = openMenu.indexOf(item.id);
        const newOpenMenu = [...openMenu];

        handleDrawerOpen();

        if (currentIndex === -1) {
            newOpenMenu.push(item.id);
        } else {
            newOpenMenu.splice(currentIndex, 1);
        }

        setOpenMenu(newOpenMenu);


        /*         if (item.subMenus.length === 0 && !isFixed) {
                    handleDrawerClose();
                } */

    };

    const generateMenu = (menues, nivel) => {

        nivel = nivel + 1

        return (

            <List dense>
                {menues.map((item) => (
                    <ListItem key={item.id} disablePadding sx={{ display: 'block' }}>
                        {/* <ListItemButton onClick={handleClick(item)} component={NavLink} to={item.to} */}
                        <ListItemButton onClick={handleClick(item)}
                            component={item.to && NavLink} // Aplicar NavLink solo si item.to esta definido
                            to={item.to ? item.to : undefined}  // Aplicar to solo si item.to esta definido
                            sx={{
                                //bgcolor: open ? 'rgba(71, 98, 255, 0.2)' : 'grey',
                                minHeight: 28,
                                justifyContent: open ? 'initial' : 'center',
                                px: 2.0,
                                pl: nivel > 0 ? nivel * 4 : 'auto'
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: open ? 1.5 : 'auto',
                                    justifyContent: 'center',
                                }}
                            >
                                {item.icon}
                            </ListItemIcon>
                            <ListItemText primaryTypographyProps={{ style: { fontSize: 14 } }} primary={item.name} sx={{ opacity: open ? 1 : 0 }} />
                            {open && item.subMenus.length > 0 && (openMenu.indexOf(item.id) !== -1 ? <ExpandLess /> : <ExpandMore />)}
                        </ListItemButton>

                        {item.subMenus.length > 0 &&
                            <Collapse in={openMenu.indexOf(item.id) !== -1} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding dense>
                                    {generateMenu(item.subMenus, nivel)}
                                </List>
                            </Collapse>
                        }
                    </ListItem>
                ))}
            </List>)
    }


    return (

        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <Navbar open={open} handleDrawerOpen={handleDrawerOpen} handleDrawerClose={handleDrawerClose} handlerDrawerFixed={handlerDrawerFixed} />

            <Drawer variant="permanent" open={open} onMouseEnter={handleDrawerOpen} onMouseLeave={() => handleDrawerClose("L")} >
                {<DrawerHeader />}

                <Box sx={{ display: 'flex', minHeight: 60, pl: 1, pb: 1, alignItems: 'end' }}>
                    <img src='./img/logo-primary1.png' style={{ width: '45px', height: '45px', justifyContent: open ? 'initial' : 'center', borderRadius: 10 }} />
                    {open ? <Typography variant="caption" noWrap component="p" align='center' paddingLeft={1} >EscoBolsa - Versión {appVersion}</Typography> : null}
                </Box>

                <Divider />
                {generateMenu(menuItems, nivel)}
                <Divider />

            </Drawer>

            <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                <DrawerHeader />
                {props.children}
            </Box>

        </Box>
    );
}

